<!-- 监控平台 -->
<template>
    <div class="campus-announcement">
        <div class="title-Box">
            <span>共计人数：{{ this.tableData.totalCount }}人</span>
            <span>在线人数：{{ this.tableData.onlineCount }}人</span>
            <span>离线人数：{{ this.tableData.offlineCount }}人</span>
            <span>报警信息人数：{{ this.tableData.warningTotalCount}}(进围栏：{{ this.tableData.entryRailCount }}条,出围栏报警：{{ this.tableData.outlineCount}} 条,低电量报警：{{ this.tableData. lowBatteryCount}}条)</span>
            <span>帮助人数：{{ this.tableData.helpCount }}人</span>
            <span>激活人数：{{ this.tableData.activateCount }}人</span>
            <span>地图：高德地图</span>
            <input type="text" placeholder=" 请输入IMEI" v-model="Dform.imei">
            <button @click="queryClick">查询</button>
        </div>
        <div class="map-container">
            <Mapview 
                :deviceLocationDetails="deviceLocationDetails" 
                :status="status" 
                :GtsDataList="GtsDataList" 
                v-if=" JSON.stringify(deviceLocationDetails) != ''"></Mapview>
        </div>
    </div>
</template>

<script>
import Mapview from "@/components/MapContainer.vue"
import {deviceDetails} from "@/assets/api/api.js"
import {deviceFindPeople} from "@/assets/api/user.js"
export default {
    components: {
        Mapview                                                                                                               
    },
    props: ['locationData','GtsData','useriTtem'],  
    data() {
        return {
            deviceLocationDetails: {},
            status: null,
            tableData:{},
            Dform:{
                imei:''
            },
            GtsDataList: []
        };
    },
    watch: {
      'useriTtem' (val){
            console.log(val.id,'我是传过来的数据');
            // this.reacquireClick(val)
            this.FindPeople(val)
           },
      'locationData' (val) {
        console.log(val,5555);
        if ( val.deviceId ) {
            console.log(val.deviceId,'设备号');
            this.deviceDetailsSearch()
        }
      },
      'GtsData' (val) {
        this.deviceLocationDetails = {}
        console.log(val,'群体位置');
        let arr = []
        val.data.forEach(item => {
            // arr.push([item.lng1,item.lat1])
            item.position = [item.lng1,item.lat1]
        })
        this.GtsDataList = val.data
        console.log(this.GtsDataList,5555555555);
      },
    },
    created() {
        this.deviceDetailsSearch()
        this.status = 1
        this.FindPeople()
    },
    mounted() {
    },
    methods: {
        queryClick(){
            // this.deviceDetailsSearch()
            let params = {
                deviceId: this.locationData.deviceId || null,
                imei:this.Dform.imei,
                userId:this.locationData.deviceId == '' ? null: JSON.parse(localStorage.getItem('user')).id
            }
            deviceDetails(params).then((res) => {
                console.log(res,"1111111111111111111");
                this.deviceLocationDetails = res.data.data
            }).catch((err)=> {
                console.log(err);
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });

            })  
        
        },
        FindPeople(item){
                if (item) {
                    deviceFindPeople(item.id).then((res)=> {
                    this.tableData = res.data.data
                    console.log(res,'二级账号监控平台');
                    
                }).catch((err)=> {
                    console.log(err,'监控平台');
                    
                })
            } else {
                
                deviceFindPeople(JSON.parse(localStorage.getItem('user')).id).then((res)=> {
                    this.tableData = res.data.data
                    console.log(res,'监控平台');
                    
                }).catch((err)=> {
                    console.log(err,'监控平台');
                    
                })
            }
        },
        deviceDetailsSearch(){
            this.GtsDataList = []
            let params = {
                deviceId: this.locationData.deviceId || null,
                imei:this.Dform.imei,
                userId:this.locationData.deviceId == '' ? null: JSON.parse(localStorage.getItem('user')).id
            }
            deviceDetails(params).then((res) => {
                console.log(res,"1111111111111111111");
                this.deviceLocationDetails = res.data.data
            }).catch((err)=> {
                console.log(err);
            })  
        }
    },
};
</script>

<style scoped lang="scss">          
.campus-announcement {
    height: 95%;
    background-color: #fff;
    .title-Box{
        height: 40px;
        line-height: 40px;
        // background: pink
        font-size: 14px
        ;
        span{
            margin-left: 15px;
        }
        input{
            margin-left: 10px;
            border: 1px solid #ccc;
            font-size: 12px;
            height: 25px;
            border-radius: 3px;
        }
        button{
            margin-left: 10px;
            height: 25px;
            width: 50px;
            border-radius: 2px;
            border: 1px solid #ccc;
        }
    }
        .map-container{
            height:95%;
            width: 100%;
            margin: 0;  
    }

    
}
</style>
